import React, { useState } from "react";
import "react-quill/dist/quill.snow.css";

function MyComponent() {
  return <div>Index</div>;
}

export default MyComponent;
